import { auth, db } from "../firebase/firebase.config.js";
import _ from "lodash";

// Stores
import { ExpenseStore } from "../store";

const getExpenseHistory = auth.onAuthStateChanged((user) => {
	if (user) {
		const uid = user.uid;
		const uidCollection = db
			.collection(uid)
			.doc("expenses")
			.collection("history");
		let uidCollectionData = {};

		if (uidCollection) {
			uidCollection
				.get()
				.then((querySnapShot) => {
					if (!querySnapShot.empty) {
						querySnapShot.forEach((doc) => {
							uidCollectionData[`${doc.id}`] = doc.data();
						});
					} else {
						console.log("data doesnt exists");
					}
				})
				.then(() => {
					if (!_.isEmpty(uidCollectionData)) {
						const yearsList = _.keys(uidCollectionData);
						const history = uidCollectionData;
						history["yearsList"] = yearsList;

						ExpenseStore.update((data) => {
							data.data[`history`] = history;
							return data;
						});
					}
				});
		}
	} else {
		console.log("no user to get data");
	}
});

export default getExpenseHistory;
